// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Route.module.css */

/* Обёртка страницы */
.Route_routeExplorer__8asMm {
  position: relative;
  min-height: 100vh;
  padding-top: 70px;
  padding-bottom: 60px;
  box-sizing: border-box;
  font-family: sans-serif;
}

/* Заголовок */
.Route_header__\\+Dssp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #007bff;
  color: #ffffff;
  padding: 10px 15px;
}

.Route_pageTitle__6OR9I {
  margin: 0;
  font-size: 20px;
}

.Route_backButton__hVwO6 {
  background: none;
  border: none;
  color: #ffffff;
  font-size: 18px;
  cursor: pointer;
}

/* Контейнер маршрута */
.Route_routePageContainer__9cRh3 {
  flex: 1 1;
  font-family: Arial, sans-serif;
  padding: 0 10px;
  height: 100%;
  overflow-y: auto;
}

/* Информационный блок */
.Route_infoBlock__q-CzF p {
  margin: 5px 0;
}

/* Панель управления */
.Route_controls__nlr7S {
  display: flex;
  justify-content: space-around;
  margin: 10px;
}

.Route_controlButton__eWrUD {
  padding: 5px 10px;
  border: none;
  background-color: #007bff;
  color: #ffffff;
  border-radius: 3px;
  cursor: pointer;
}

.Route_controlButton__eWrUD:hover {
  background-color: #0056b3;
}

/* Фильтр и поиск (FilterMenu.module.css) */
/* Импортируется из отдельного модуля */

/* Форма поиска */
.Route_searchForm__mitLj {
  display: flex;
  justify-content: center;
  margin: 0 15px 10px;
}

.Route_searchForm__mitLj input {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
  flex: 1 1;
}

.Route_searchForm__mitLj button {
  padding: 5px 10px;
  background-color: #007bff;
  color: #ffffff;
  border: none;
  border-radius: 3px;
  margin-left: 5px;
  cursor: pointer;
}

.Route_searchForm__mitLj button:hover {
  background-color: #0056b3;
}

/* Список квитанций */
.Route_receiptsContainer__Ipem9 {
  padding: 0;
}

.Route_groupContainer__PxSTy {
  background-color: #e9ecef;
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 5px;
}

.Route_groupHeader__kk8EP {
  font-weight: bold;
  padding: 5px;
  border-bottom: 1px solid #ccc;
}

.Route_receiptCard__4qUGQ {
  background-color: #ffffff;
  margin: 5px 0;
  padding: 10px;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  cursor: pointer;
  position: relative;
}

.Route_receiptHeader__Tqwpu {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Route_address__dzm0p {
  font-weight: bold;
}

.Route_time__VfpKG {
  font-size: 12px;
  color: #555;
}

.Route_icons__c4zzS {
  display: flex;
  gap: 10px;
  font-size: 24px;
}

.Route_icon__ySJiY {
  cursor: pointer;
}

.Route_receiptDetails__rXfhA {
  margin-top: 8px;
  border-top: 1px solid #eee;
  padding-top: 5px;
  font-size: 14px;
}

.Route_detailItem__\\+M9n9 {
  margin: 3px 0;
}

.Route_callButton__5rb5S {
  margin-left: 10px;
  padding: 3px 6px;
  background-color: #28a745;
  color: #ffffff;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.Route_callButton__5rb5S:hover {
  background-color: #218838;
}

.Route_noReceipts__ioQcW {
  text-align: center;
  margin-top: 15px;
  font-style: italic;
}

/* Модальное окно */
.Route_modalOverlay__yOSus {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.Route_modalContent__-ZK4P {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 600px;
}

.Route_disabled__zRZ01 {
  background-color: #d3d3d3;
  color: #a0a0a0;
  cursor: not-allowed;
}

/* Статусная полоса */
.Route_statusIndicator__453O8 {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  border-radius: 5px 0 0 5px;
}

/* Статистика маршрута */
.Route_routeStats__N\\+NqI {
  margin: 0.25em 0;
  font-size: 0.9em;
  color: #555;
}

.Route_routeStats__N\\+NqI strong {
  color: #222;
}`, "",{"version":3,"sources":["webpack://./src/modules/Courier/Route/Route.module.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB,qBAAqB;AACrB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C,uCAAuC;;AAEvC,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* Route.module.css */\r\n\r\n/* Обёртка страницы */\r\n.routeExplorer {\r\n  position: relative;\r\n  min-height: 100vh;\r\n  padding-top: 70px;\r\n  padding-bottom: 60px;\r\n  box-sizing: border-box;\r\n  font-family: sans-serif;\r\n}\r\n\r\n/* Заголовок */\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: #007bff;\r\n  color: #ffffff;\r\n  padding: 10px 15px;\r\n}\r\n\r\n.pageTitle {\r\n  margin: 0;\r\n  font-size: 20px;\r\n}\r\n\r\n.backButton {\r\n  background: none;\r\n  border: none;\r\n  color: #ffffff;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Контейнер маршрута */\r\n.routePageContainer {\r\n  flex: 1;\r\n  font-family: Arial, sans-serif;\r\n  padding: 0 10px;\r\n  height: 100%;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Информационный блок */\r\n.infoBlock p {\r\n  margin: 5px 0;\r\n}\r\n\r\n/* Панель управления */\r\n.controls {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  margin: 10px;\r\n}\r\n\r\n.controlButton {\r\n  padding: 5px 10px;\r\n  border: none;\r\n  background-color: #007bff;\r\n  color: #ffffff;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n.controlButton:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n/* Фильтр и поиск (FilterMenu.module.css) */\r\n/* Импортируется из отдельного модуля */\r\n\r\n/* Форма поиска */\r\n.searchForm {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 0 15px 10px;\r\n}\r\n\r\n.searchForm input {\r\n  padding: 5px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 3px;\r\n  flex: 1;\r\n}\r\n\r\n.searchForm button {\r\n  padding: 5px 10px;\r\n  background-color: #007bff;\r\n  color: #ffffff;\r\n  border: none;\r\n  border-radius: 3px;\r\n  margin-left: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.searchForm button:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n/* Список квитанций */\r\n.receiptsContainer {\r\n  padding: 0;\r\n}\r\n\r\n.groupContainer {\r\n  background-color: #e9ecef;\r\n  margin-bottom: 10px;\r\n  border-radius: 5px;\r\n  padding: 5px;\r\n}\r\n\r\n.groupHeader {\r\n  font-weight: bold;\r\n  padding: 5px;\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.receiptCard {\r\n  background-color: #ffffff;\r\n  margin: 5px 0;\r\n  padding: 10px;\r\n  border-radius: 3px;\r\n  box-shadow: 0 1px 2px rgba(0,0,0,0.1);\r\n  cursor: pointer;\r\n  position: relative;\r\n}\r\n\r\n.receiptHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.address {\r\n  font-weight: bold;\r\n}\r\n\r\n.time {\r\n  font-size: 12px;\r\n  color: #555;\r\n}\r\n\r\n.icons {\r\n  display: flex;\r\n  gap: 10px;\r\n  font-size: 24px;\r\n}\r\n\r\n.icon {\r\n  cursor: pointer;\r\n}\r\n\r\n.receiptDetails {\r\n  margin-top: 8px;\r\n  border-top: 1px solid #eee;\r\n  padding-top: 5px;\r\n  font-size: 14px;\r\n}\r\n\r\n.detailItem {\r\n  margin: 3px 0;\r\n}\r\n\r\n.callButton {\r\n  margin-left: 10px;\r\n  padding: 3px 6px;\r\n  background-color: #28a745;\r\n  color: #ffffff;\r\n  border: none;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n.callButton:hover {\r\n  background-color: #218838;\r\n}\r\n\r\n.noReceipts {\r\n  text-align: center;\r\n  margin-top: 15px;\r\n  font-style: italic;\r\n}\r\n\r\n/* Модальное окно */\r\n.modalOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.modalContent {\r\n  background-color: #ffffff;\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  width: 90%;\r\n  max-width: 600px;\r\n}\r\n\r\n.disabled {\r\n  background-color: #d3d3d3;\r\n  color: #a0a0a0;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Статусная полоса */\r\n.statusIndicator {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 5px;\r\n  border-radius: 5px 0 0 5px;\r\n}\r\n\r\n/* Статистика маршрута */\r\n.routeStats {\r\n  margin: 0.25em 0;\r\n  font-size: 0.9em;\r\n  color: #555;\r\n}\r\n\r\n.routeStats strong {\r\n  color: #222;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"routeExplorer": `Route_routeExplorer__8asMm`,
	"header": `Route_header__+Dssp`,
	"pageTitle": `Route_pageTitle__6OR9I`,
	"backButton": `Route_backButton__hVwO6`,
	"routePageContainer": `Route_routePageContainer__9cRh3`,
	"infoBlock": `Route_infoBlock__q-CzF`,
	"controls": `Route_controls__nlr7S`,
	"controlButton": `Route_controlButton__eWrUD`,
	"searchForm": `Route_searchForm__mitLj`,
	"receiptsContainer": `Route_receiptsContainer__Ipem9`,
	"groupContainer": `Route_groupContainer__PxSTy`,
	"groupHeader": `Route_groupHeader__kk8EP`,
	"receiptCard": `Route_receiptCard__4qUGQ`,
	"receiptHeader": `Route_receiptHeader__Tqwpu`,
	"address": `Route_address__dzm0p`,
	"time": `Route_time__VfpKG`,
	"icons": `Route_icons__c4zzS`,
	"icon": `Route_icon__ySJiY`,
	"receiptDetails": `Route_receiptDetails__rXfhA`,
	"detailItem": `Route_detailItem__+M9n9`,
	"callButton": `Route_callButton__5rb5S`,
	"noReceipts": `Route_noReceipts__ioQcW`,
	"modalOverlay": `Route_modalOverlay__yOSus`,
	"modalContent": `Route_modalContent__-ZK4P`,
	"disabled": `Route_disabled__zRZ01`,
	"statusIndicator": `Route_statusIndicator__453O8`,
	"routeStats": `Route_routeStats__N+NqI`
};
export default ___CSS_LOADER_EXPORT___;
